import { Room, TwilioError } from 'twilio-video';
import { useEffect } from 'react';
import { Callback } from '../../../types';

export default function useHandleRoomDisconnection(
  room: Room | null,
  onError: Callback,
  removeLocalAudioTrack: () => void,
  removeLocalVideoTrack: () => void,
  isSharingScreen: boolean,
  toggleScreenShare: () => void
) {
  useEffect(() => {
    if (room) {
      const onDisconnected = (_: Room, error: TwilioError) => {
        // Guardamos el bloqueo antes de salir
        window.sessionStorage.setItem('meeting_ended', 'true');

        if (error) {
          onError(error);
        }

        removeLocalAudioTrack();
        removeLocalVideoTrack();

        if (isSharingScreen) {
          toggleScreenShare();
        }

        const urlParams = new URLSearchParams(window.location.search);
        const isEntrenador = urlParams.get('entrenador') === 'true';
        const redirectUrl = isEntrenador
          ? 'https://app.walba.app/#!/home'
          : 'https://client.walba.app/app/tabs/schedule';

        // Redirección segura
        window.parent.postMessage({ action: 'redirect', url: redirectUrl }, '*');
      };

      room.on('disconnected', onDisconnected);
      return () => {
        room.off('disconnected', onDisconnected);
      };
    }
  }, [room, onError, removeLocalAudioTrack, removeLocalVideoTrack, isSharingScreen, toggleScreenShare]);
}
